<footer class="container app-footer">
  <div class="app-footer__content hidden-sm-down">
    <p class="app-footer__tos" i18n="@@footerRightsReservedErikorgu">
      The "Fitcat" website and mobile apps are managed by Dietless OÜ (registered with company no. 12840366 at Tartu mnt 84a-112, 10112
      Tallinn). All rights reserved. "Fitcat" (© 2017) is a registered trademark.
      <span class="app-footer__links">
        Use of our services, website and app is subject to our
        <a href="#" (click)="showPopup('terms'); (false)">Terms of Use</a>.
      </span>
    </p>
  </div>
</footer>
